import {
  PROP_CONTEXT_DIMENSION1,
  PROP_CONTEXT_DIMENSION3,
  PROP_FORM_LIST,
  PROP_TRACK_ACTION,
} from '../constants';
import { trackCustomPage, trackAction } from '../tracker';

export const companyPageCreationTracking: any = {
  step0: {
    stepView: {
      pageName: 'wbm/EntityPages/pages/company_profile_creation_basic_info',
      nwtPageName: 'entity_pages/company_profile_creation/basic_info',
      [PROP_FORM_LIST]: 'entity_page_company_profile_creation_form_open',
    },
    nextAction: 'recruiting_company_page_creation_contact_2',
  },
  step1: {
    stepView: {
      pageName: 'wbm/EntityPages/pages/company_profile_creation_contact_detail',
      nwtPageName: 'entity_pages/company_profile_creation/contact_details',
    },
    nextAction: 'recruiting_company_page_creation_logo_3',
  },
  step2: {
    stepView: {
      pageName: 'wbm/EntityPages/pages/company_profile_creation_logo',
      nwtPageName: 'entity_pages/company_profile_creation/company_logo',
    },
    nextAction: 'recruiting_company_page_creation_description_4',
  },
  step3: {
    stepView: {
      pageName: 'wbm/EntityPages/pages/company_profile_creation_description',
      nwtPageName: 'entity_pages/company_profile_creation/description',
    },
    nextAction: 'recruiting_company_page_create_5',
  },
  step4: {
    stepView: {
      pageName: 'wbm/EntityPages/pages/company_profile_creation_confirmation',
      nwtPageName: 'entity_pages/company_profile_creation/confirmation',
      EventCompaniesProfileCreate: 1,
      [PROP_CONTEXT_DIMENSION1]: 'entity_page_basic',
      [PROP_CONTEXT_DIMENSION3]: 'entity_page_editor',
      [PROP_FORM_LIST]: 'entity_page_company_profile_creation_form_sent',
    },
    nextAction: 'recruiting_company_page_create_5',
  },
};

export const trackCompanyPageCreationStep = (currentStep: number) => {
  const stepView =
    companyPageCreationTracking?.[`step${currentStep}`]?.stepView;

  const { pageName, ...context } = stepView;
  if (pageName) trackCustomPage(pageName, {}, context);
};

export const trackCompanyPageCreationNextAction = (
  currentStep: 0 | 1 | 2 | 3
) => {
  const nextAction =
    companyPageCreationTracking?.[`step${currentStep}`].nextAction;

  if (nextAction) trackAction({ [PROP_TRACK_ACTION]: nextAction });
};
